import React from 'react';
import './title.css';

const Title = ({ thread: { title, user, url } }) => (
  <div className='title-container'>
    <p className="title">{title}</p>
    <div className="posted-by">
      Posted by: <span>{user.name}</span>
    </div>
    {url &&
      <a className="title-hyperlink" href={url} target="_blank">
        {url}
      </a>
    }
  </div>
);

export default Title;